import React from "react";
import { PriorityEnum } from "../../../../../../utils/Enum.types";

const Legends = () => {
  const Priority = Object.values(PriorityEnum).filter((priority) => priority !== PriorityEnum.ALL);

  return (
    <div className="raise-ticket-legends">
      {Priority.map((res) => {
        return (
          <span
            className={
              res === PriorityEnum.CRITICAL
                ? "border-red"
                : res === PriorityEnum.MEDIUM
                ? "border-yellow"
                : res === PriorityEnum.LOW
                ? "border-green"
                : ""
            }
          >
            {res}
          </span>
        );
      })}
    </div>
  );
};

export default Legends;
